/* eslint-disable react/prop-types */

import React, { useContext } from 'react';
import { AppContext } from '../../components/app/AppProvider.component';
import cx from 'classnames';
import { ELSIcon, } from '../../components/els.components';
import {
  ActivityTypeConfigMap,
} from '../../models/remediation.models';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexItem } from '../../components/flex/FlexItem.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { AssessmentGoalDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { RemediationActivityTypeDto } from '../../apis/nhe-remediation-service/nhe-remediation-service.dtos';
import {
  getAssessmentGoalTotalsCombined,
  getCategoryGroupNameForGoal,
  getContentTypeMainDisplay,
  getContentTypesFromActivityType,
  getGoalBreadcrumbs,
  getMetricCounts,
  getProgressDisplay,
  isGoalComplete,
  sortAssessmentGoals
} from '../../utilities/remediation.utilities';

export type RemediationActivitySectionProps = {
  activityType: RemediationActivityTypeDto;
  onTaxonClick: (assessmentGoal: AssessmentGoalDto) => void;
};

const RemediationActivitySection = (props: RemediationActivitySectionProps): JSX.Element => {

  const { appState } = useContext(AppContext);
  const baseState = appState.remediationBaseState;

  const {
    activityType,
  } = props;

  let assessmentGoals: AssessmentGoalDto[] = null;

  if (baseState?.eolsAssessment) {
    assessmentGoals = baseState.eolsAssessment.assessmentGoals?.filter((goal) => {
      return goal.type === activityType;
    });
    assessmentGoals = sortAssessmentGoals(assessmentGoals);
  }

  const metricCounts = getMetricCounts(baseState, activityType);
  const isActivityTypeComplete = isGoalComplete(metricCounts);
  const contentTypes = getContentTypesFromActivityType(activityType, baseState);
  const contentTypesDisplay = getContentTypeMainDisplay(contentTypes, null);

  return (
    <div className={`c-nra-remediation-activity-section c-nra-remediation-activity-section--${activityType.toLowerCase()}`}>

      <div className="c-nra-remediation-activity-section__checklist-header">

        <div>
          <FlexLayout
            modifiers={[
              FlexLayoutModifier.BOTTOM,
            ]}
          >
            <FlexItem
              modifiers={[
                FlexLayoutModifier.GROW,
              ]}>
              <h3>
                <strong>{ActivityTypeConfigMap[activityType].title}: {contentTypesDisplay}</strong>
              </h3>
            </FlexItem>
            <FlexItem>
              <div className="u-els-color-n7">{getProgressDisplay(metricCounts, activityType)}</div>
            </FlexItem>
          </FlexLayout>

        </div>

      </div>

      {
        activityType === RemediationActivityTypeDto.ASSESS_BY_CONTENT_TYPE
        && baseState?.quizAttemptDetails
        && !isActivityTypeComplete
        && baseState.quizAttemptDetails.correctQuestionThreshold < baseState.quizAttemptDetails.totalItems
        && (
          <div className="o-els-container">
            You must attempt all <strong>{baseState.quizAttemptDetails.totalItems}</strong> questions and answer at
            least <strong>{baseState.quizAttemptDetails.correctQuestionThreshold}</strong> correctly.
          </div>
        )
      }

      {assessmentGoals && (
        <div>
          {
            assessmentGoals
              .filter((assessmentGoal) => {
                return assessmentGoal.type === activityType;
              })
              .map((assessmentGoal) => {

                const goalMetricCounts = getAssessmentGoalTotalsCombined({
                  assessmentGoal,
                  baseState,
                });

                const goalBreadcrumbs = getGoalBreadcrumbs(assessmentGoal, getCategoryGroupNameForGoal(assessmentGoal, baseState));

                return (
                  <button
                    type="button"
                    onClick={() => props.onTaxonClick(assessmentGoal)}
                    key={assessmentGoal.vtwId}
                    className={
                      cx(
                        'u-els-debuttonize',
                        'c-nra-remediation-activity-section__checklist-item',
                        {
                          'c-nra-remediation-activity-section__checklist-item--completed': isGoalComplete(goalMetricCounts)
                        }
                      )
                    }
                  >
                    <FlexLayout
                      modifiers={[
                        FlexLayoutModifier.MIDDLE,
                        FlexLayoutModifier.GUTTERS_1o2
                      ]}
                    >
                      <FlexItem>
                        <ELSIcon
                          name={isGoalComplete(goalMetricCounts) ? 'checkmark' : ''}
                          prefix="hmds"
                          size="1x"
                          customClass="c-nra-remediation-activity-section__checklist-item-icon"
                        />
                      </FlexItem>
                      <FlexItem
                        modifiers={[
                          FlexLayoutModifier.GROW,
                        ]}>
                        <div className="c-nra-remediation-activity-section__checklist-item-text">
                          {goalBreadcrumbs.path && goalBreadcrumbs.path.length > 0 && (
                            <div className="u-els-margin-bottom-1o4">
                              {goalBreadcrumbs.pathDisplay}
                            </div>
                          )}
                          <div>
                            <strong>{goalBreadcrumbs.text}</strong>
                            <span>&nbsp;&bull;&nbsp;</span>
                            <span className="u-els-color-n8">{getProgressDisplay(goalMetricCounts, activityType)}</span>
                          </div>
                        </div>
                      </FlexItem>
                      <FlexItem>
                        <ELSIcon
                          size="1x"
                          prefix="gizmo"
                          name="arrow-right"
                          customClass="c-nra-remediation-activity-section__checklist-item-icon"
                        />
                      </FlexItem>
                    </FlexLayout>
                  </button>
                );
              })
          }
        </div>
      )}
    </div>
  );
};
export default RemediationActivitySection;
